<template>
  <div>
    <div class="cus-panel-heading">
      <h4 class="cus-panel-title">Export Orders</h4>
    </div>

    <div
      class="panel-body"
      style="display: block;"
    >
      <div class="row">
        <preDatatableComponent
          :removeAddButton="true"
          :removeWarehouseDeliverButton="true"
          :showAddExportOrderButton="true"
          :handleAddExportOrder="handleAddExportOrder"
          :checkAlert="checkAlert"
          :tableData="tableData"
          :resetGetResults="resetGetResults"
          :resetGetResults2="resetGetResults2"
          :searchMe="searchMe"
          :pagination="pagination"
          :perPageFix="perPageFix"
          :filterTable="filterTable"
          :hideSelectingColumn="true"
        ></preDatatableComponent>
        <div class="col-xs-12">
          <v-layout
            row
            wrap
          >
            <v-flex
              v-for="status in statusesList"
              :key="status.value"
              xs6
              sm2
              md2
              lg2
              xl1
              class="mb-3 text-center"
            >
              <div
                class="label pointer not-selectable custom-label"
                :class="status.color"
                :style="(status.value === 0 && tableData.statuses.length === 0) || (status.value !== 0 && tableData.statuses.includes(status.value)) ? 'border: 2px solid #000;' : ''"
                @click="filterByStatus(status.value)"
              >
                {{ status.text }}
              </div>
            </v-flex>
          </v-layout>
          <datatable
            v-if="!isMobile"
            :sortDir="tableData.sortDir"
            :columns="columns"
            :sortByColumn="sortByColumn"
            :searchOneCol="searchOneCol"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
          >
            <tbody>
              <tr
                v-for="r in apiResults"
                :key="r.export_order_id"
              >
                <td>{{ r.order_number }}</td>
                <td>{{ r.product_name }}</td>
                <td>{{ r.quantity }}</td>
                <td>{{ r.country_name }}</td>
                <td>
                  <span
                    class="label"
                    :class="{
                      'bg-orange-600': r.status === 1,
                      'bg-indigo-600': r.status === 2,
                      'bg-danger-600': r.status === 3,
                      'bg-green-600': r.status === 4,
                      'bg-primary-600': r.status === 5,
                      'bg-teal-600': r.status === 6,
                      'bg-purple-600': r.status === 7
                    }"
                  >
                    {{ r.status_text }}
                  </span>
                </td>
                <td>{{ r.price | usdFormat }}</td>
                <td>{{ r.created_at | moment('YYYY-MM-DD hh:mm a') }}</td>
                <router-link
                  :to="'/my-export-order-detail/' + r.export_order_id"
                  tag="td"
                  style="padding-left:0px; padding-right:5px"
                >
                  <a tooltip="Order Detail">
                    <i class="material-icons">
                      aspect_ratio
                    </i>
                  </a>
                </router-link>
                <!-- <router-link
                  v-if="r.status_id_fk == 1"
                  :to="`/make-new-order?export_order_id=${r.export_order_id}`"
                  tag="td"
                  style="padding-left:0px; padding-right:5px"
                >
                  <a tooltip="Edit Order"><i
                      class="fa fa-edit"
                      style="font-size: 22px"
                    /></a>
                </router-link> -->
                <td
                  v-if="r.status === 1 || r.status === 2"
                  style="padding-left:0px; padding-right:5px"
                >
                  <a
                    @click="openCancelingOrderModal(r.export_order_id)"
                    style="color:#C62828"
                    tooltip="Cancel Order"
                  >
                    <i class="material-icons">cancel</i>
                  </a>
                </td>
                <td
                  v-if="r.status === 2"
                  style="padding-left:0px; padding-right:5px"
                >
                  <a
                    @click="approvingOrder(r.export_order_id)"
                    style="color:#43A047"
                    tooltip="Approve Order"
                  >
                    <i class="material-icons">check_circle</i>
                  </a>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  :colspan="columns.length"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    No Results Found
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </datatable>

          <!-- %%%%%%%%% Mobile Table %%%%%%%%%% -->

          <mobile-datatable
            :isOrder="true"
            v-if="isMobile"
          >
            <tbody>
              <tr
                v-for="r in apiResults"
                :key="r.export_order_id"
              >
                <td>
                  {{ r.order_number }}, <br />
                  {{ r.product_name }} , <br />
                  <br />
                  {{ r.country_name }} ,
                  <br />
                  Quantity : {{ r.quantity }}
                </td>
                <td>
                  <span
                    class="label"
                    :class="{
                      'bg-warning-600': r.status === 1,
                      'bg-indigo-600': r.status === 2,
                      'bg-danger-600': r.status === 3,
                      'bg-green-600': r.status === 4,
                      'bg-primary-600': r.status === 5,
                      'bg-teal-600': r.status === 6,
                      'bg-purple-600': r.status === 7
                    }"
                  >
                    {{ r.status_text }}
                  </span>
                  <br />
                  <span> {{ r.created_at | moment('YYYY-MM-DD hh:mm a') }}</span>
                  <br />
                  <router-link
                    :to="'/my-export-order-detail?id=' + r.export_order_id"
                    tag="span"
                    style="display: inline-block; padding-left:0px; padding-right:3px"
                  ><a tooltip="Order Detail"><i class="material-icons">aspect_ratio</i></a></router-link>
                  <span style="padding-left:0px; padding-right:3px">
                    <a
                      v-if="r.status === 1"
                      @click="openCancelingOrderModal(r.export_order_id)"
                      style="color:#C62828"
                      tooltip="Cancel Order"
                    >
                      <i class="material-icons">cancel</i>
                    </a>

                    <a
                      v-if="r.status === 2"
                      @click="approvingOrder(r.export_order_id)"
                      style="color:#43A047"
                      tooltip="Approve Order"
                    >
                      <i class="material-icons">check_circle</i>
                    </a>
                  </span>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  colspan="2"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    No Results Found
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </mobile-datatable>

          <customer-cancel-export-order
            :cancelModal="cancelModal"
            :id="orderId"
            @close="cancelModal = false"
          />

          <hr />
          <div class="row">
            <div class="col-xs-12 text-right">
              <pagination
                :page-count="pagination.lastPage"
                :page-range="2"
                :changePage="changePage"
                :container-class="'pagination'"
                :pagination="pagination"
                :page-class="'page-item'"
              >
              </pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '../../Pagination.vue'
import preDatatableComponent from '../../preDatatableComponent.vue'
import Datatable from '../../Datatable.vue'
import mobileDatatable from '../../mobileDatatable'
import customerCancelExportOrder from './customerCancelExportOrder'
import axios from 'axios'
import swal from 'sweetalert'

export default {
  components: {
    preDatatableComponent,
    Datatable,
    Pagination,
    customerCancelExportOrder,
    mobileDatatable
  },
  created() {
    this.getLoggedInUser()
  },
  mounted() {
    if (!this.loggedInUserData.is_staff) {
      this.getUser()
    }
    this.perPageFix()

    if (screen.width <= 600) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  },
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    let sortOrders = {}
    let columns = [
      { label: 'Order No.', sortable: true, searchable: true, name: 'order_number' },
      { label: 'Product Name', sortable: true, searchable: true, name: 'product_name' },
      { label: 'Quantity', sortable: true, searchable: true, name: 'quantity' },
      { label: 'Country', sortable: true, searchable: true, name: 'country_name' },
      { label: 'Status', sortable: true, searchable: true, name: 'status' },
      { label: 'Price', sortable: true, searchable: true, name: 'price' },
      { label: 'Date', sortable: true, searchable: true, name: 'created_at' }
    ]
    columns.forEach((column) => {
      sortOrders[column.name] = -1
    })

    return {
      orderId: 0,
      isMobile: false,
      url: 'api/my-export-order',
      alertValue: false,
      checkAlert: false,
      loggedInUserData: {},
      statusesList: [
        { text: 'All', value: 0, color: 'bg-grey-600' },
        { text: 'Pending', value: 1, color: 'bg-orange-600' },
        { text: 'Canceled', value: 3, color: 'bg-danger-600' },
        { text: 'Approved', value: 4, color: 'bg-green-600' },
        { text: 'Sent', value: 5, color: 'bg-primary-600' },
        { text: 'Received', value: 6, color: 'bg-teal-600' },
        { text: 'Refunded', value: 7, color: 'bg-purple-600' }
      ],
      prevSearchQuery: '',
      apiResults: [],
      columns: columns,
      sortKey: 'updated_at',
      sortOrders: sortOrders,
      cancelModal: false,
      tableData: {
        per_page: 10,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        statuses: []
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    }
  },

  methods: {
    handleAddExportOrder() {
      this.$router.push('/add-new-export-order')
    },

    filterByStatus(status) {
      if (status === 0) {
        this.tableData.statuses = []
      } else {
        this.tableData.statuses = [status]
      }
      this.getResults()
    },

    openCancelingOrderModal(orderId) {
      this.cancelModal = true
      this.orderId = orderId
    },

    getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'))
    },

    getUser() {
      let token = localStorage.getItem('access_token')
      axios.get('api/me', { headers: { Authorization: 'Bearer ' + token } }).then((response) => {
        localStorage.setItem('user_data', JSON.stringify(response.data))
      })
    },

    getResults(url = this.url) {
      var token = localStorage.getItem('access_token')
      let theDatatable = document.querySelector('.the-datatable')
      let thePanel = document.querySelector('.panel-flat')

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out')
        thePanel.style.overflowX = 'auto'
      }

      axios
        .get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          let data = response.data
          this.apiResults = data.data.data

          if (this.apiResults.length === 0) {
            this.tableData.searchOneCol = ''
            this.tableData.searchOneVal = ''
            this.tableData.search = ''
            this.alertValue = true
          } else {
            this.alertValue = false
          }
          this.configPagination(data.data)
          theDatatable.classList.remove('slide-table-out')
          setTimeout(function () {
            thePanel.style.overflowX = 'auto'
          }, 0)
        })
        .catch((errors) => { })
    },

    resetGetResults() {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    resetGetResults2() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    perPageFix(perPage) {
      this.tableData.per_page = perPage
      this.getResults()
    },

    approvingOrder(id) {
      swal({
        title: 'Are you sure?',
        icon: 'warning',
        buttons: true
      }).then((approved) => {
        if (approved) {
          let token = localStorage.getItem('access_token')
          axios
            .get(`api/export-order/${id}/customer-approve`, {
              headers: { Authorization: 'Bearer ' + token }
            })
            .then(() => {
              this.getResults()
              swal({
                title: 'Done',
                icon: 'success',
                timer: 1500,
                buttons: false
              })
            })
            .catch((error) => {
              if (error.response) {
                swal('Error', `${error.response.data.message}`, 'error')
              }
            })
        }
      })
    },

    filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate
      this.tableData.to_date = toDate
      this.getResults()
    },

    changePage(pageUrl) {
      this.url = pageUrl
      this.getResults()
    },

    searchMe(str) {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      if (str.trim() !== '') {
        this.tableData.search = str
        this.prevSearchQuery = str
        this.getResults()
      } else {
        swal({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        })
        if (this.prevSearchQuery !== '') {
          this.tableData.search = ''
          this.prevSearchQuery = ''
          this.getResults()
        }
      }
    },

    sortByColumn(str) {
      this.tableData.column = str
      this.tableData.sortKey = str
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc'
      this.getResults()
    },

    searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName
      this.tableData.searchOneVal = str
      this.getResults()
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.lastPageUrl = data.last_page_url
      this.pagination.nextPageUrl = data.next_page_url
      this.pagination.prevPageUrl = data.prev_page_url
      this.pagination.from = data.from
      this.pagination.to = data.to
    }
  }
}
</script>

<style>
@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.btn {
  transition: all 0.5s;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden;
  overflow-y: hidden;
}

.has-error .select2-selection--single:not([class*='bg-']):not([class*='border-']) {
  border-bottom-color: red;
}

@media screen and (max-width: 767px) {
  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}

.pointer {
  cursor: pointer;
}

.not-selectable {
  user-select: none;
}

.custom-label {
  font-size: 11px;
  border-radius: 4px;
  padding: 2px 10px;
  width: 95%;
}
</style>



// WEBPACK FOOTER //
// src/components/customer/exportOrder/myExportOrders.vue